import { ActionDateFacetValue } from 'modules/search/constants/searchFacets/actionDateFacet';
import { SearchFiltersById } from 'modules/search/types/SearchFiltersById';
import { SearchSortType } from 'modules/search/types/SearchSortType';

import { searchAlgoliaIndex } from './searchAlgoliaIndex';
import { searchAlgoliaVolopsIndex } from './searchAlgoliaVolopsIndex';

export const searchAlgoliaIndexSwitch = ({
  filtersById,
  sort,
}: {
  filtersById: SearchFiltersById;
  sort: SearchSortType;
}) => {
  switch (filtersById.type) {
    case 'VOLOP':
      return searchAlgoliaVolopsIndex({
        sort,
        actionDate: filtersById.actionDateFacet as
          | ActionDateFacetValue
          | null
          | undefined,
      });
    case 'EVENT':
      return searchAlgoliaVolopsIndex({
        sort,
        actionDate: filtersById.actionDateFacet as
          | ActionDateFacetValue
          | null
          | undefined,
      });
    default:
      return searchAlgoliaIndex(sort);
  }
};
